import React, { useEffect, useState } from 'react';
import Switch from 'react-switch';
import {Formik} from 'formik';
import {TextArea} from '@react-ui-org/react-ui';
import Select from 'react-select';

export const InputsFormularioMiEmpresa = (props) => {
	const {empresa, handleInpuntChange, filtroShareCare, handleChangeTamañoEmpresa, isDisabled} = props;

	const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [ListaLocalidadesOpciones, setListaLocalidadesOpciones] = useState([]);
	const [localidadSeleccionada, setLocalidadSeleccionada] = useState();

	useEffect(()=>{
		const localidadStorage = localStorage.getItem('localidades')
		if(localidadStorage){
			const localidades = JSON.parse(localidadStorage);
			let listaAux = [{'id':0,'nombre':'Todas'}]
			let opciones = []
			localidades.forEach((localidad)=>{
				listaAux.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
					codigoPostal: localidad.codigoPostal
				});
				opciones.push({value: localidad.id, label: localidad.nombre})
			})

			setListaLocalidades(listaAux);
			setListaLocalidadesOpciones(opciones)
		}
	},[])

	useEffect(() => {
		setLocalidadSeleccionada(empresa?.localidad || 0);
	}, [empresa?.localidad]);

	return (
		<>
			{/* <div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Nombre prestador</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Nombre del prestador del servicio'}
						name={'nombreEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.nombreEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Nombre contacto </div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Nombre de contacto'}
						name={'nombreContactoEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.nombreContactoEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Apellidos contacto </div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Apellido de contacto'}
						name={'apellidosContactoEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.apellidosContactoEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Teléfono</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'telefono'}
						name={'telefono'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.telefono}
					/>
				</div>
			</div>

			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Dirección</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Dirección'}
						name={'direccion'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.direccion}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Código postal</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Código postal'}
						name={'codigoPostal'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.codigoPostal}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Web Empresa</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'www.webEmpresa.com'}
						name={'webEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.webEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Email</div>
				<div>
					<input
						type='email'
						className='inputTextUsuario'
						placeholder={'empresa@email.com'}
						name={'emailEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.emailEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Tamaño empresa</div>
				<div>
					<input
						type='number'
						className='inputTextUsuario'
						value={empresa.tamañoEmpresa}
						placeholder={1}
						name={'tamañoEmpresa'}
						onChange={handleChangeTamañoEmpresa}
						disabled={isDisabled}
					/>
				</div>
			</div>

			<div className='datoFormularioUsuario textarea1'>
				<div className='labelDatoFormUsu'>Descripción</div>
				<TextArea
					Id='textArea'
					placeholder={empresa.descripcionEmpresa}
					name={'descripcionEmpresa'}
					onChange={handleInpuntChange}
					fullWidth={true}
					disabled={isDisabled}
				/>
			</div>
			<div className='datoFormularioUsuario textarea2'>
				<div className='labelDatoFormUsu'>Notas</div>
				<TextArea
					Id='textArea'
					placeholder={empresa.notasEmpresa}
					name={'notasEmpresa'}
					onChange={handleInpuntChange}
					fullWidth={true}
					size='large'
					disabled={isDisabled}
				/>
			</div> */}

			 <div className='my-1'>
				<div className='labelDatoFormUsu'>Nombre de la empresa</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='Nombre de la empresa'
					name='nombreEmpresa'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.nombreEmpresa}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Email</div>
				<div>
					<input
					type='email'
					className='form-control text-dark'
					placeholder='empresa@email.com'
					name='emailEmpresa'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.emailEmpresa}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Nombre de contacto</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='Nombre de contacto'
					name='nombreContactoEmpresa'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.nombreContactoEmpresa}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Apellidos de contacto</div>
				<div>
					<input
						type='text'
						className='form-control text-dark'
						placeholder='Apellido de contacto'
						name='apellidosContactoEmpresa'
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.apellidosContactoEmpresa}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Localidad</div>
				<div>
					<Select		
						options={ListaLocalidadesOpciones}
						value={ListaLocalidadesOpciones.find(option => option.value === localidadSeleccionada)}
						placeholder="Localidad"
						onChange={(option) => {
							setLocalidadSeleccionada(option.value);
						}}
						isDisabled={isDisabled}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Código postal</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='Código postal'
					name='codigoPostal'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.codigoPostal}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Dirección</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='Dirección'
					name='direccion'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.direccion}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Teléfono</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='Teléfono'
					name='telefono'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.telefono}
					/>
				</div>
			</div>

			<div className='my-1'>
				<div className='labelDatoFormUsu'>Web de la empresa</div>
				<div>
					<input
					type='text'
					className='form-control text-dark'
					placeholder='www.webEmpresa.com'
					name='webEmpresa'
					onChange={handleInpuntChange}
					disabled={isDisabled}
					value={empresa.webEmpresa}
					/>
				</div>
			</div>

				{/* <div className='datoFormularioUsuario'>
					<div className='labelDatoFormUsu'>Tamaño empresa</div>
					<div>
						<input
						type='number'
						className='inputTextUsuario'
						placeholder='1'
						name='tamañoEmpresa'
						onChange={handleChangeTamañoEmpresa}
						disabled={isDisabled}
						value={empresa.tamañoEmpresa}
						/>
					</div>
				</div> */}

			<div className='my-1 textarea1'>
				<div className='labelDatoFormUsu'>Descripción</div>
				<TextArea
					Id='textArea'
					placeholder={empresa.descripcionEmpresa}
					name='descripcionEmpresa'
					onChange={handleInpuntChange}
					fullWidth={true}
					disabled={isDisabled}
				/>
			</div>

				{ <div className='datoFormularioUsuario textarea2'>
					<div className='labelDatoFormUsu'>Notas</div>
					<TextArea
						Id='textArea'
						placeholder={empresa.notasEmpresa}
						name='notasEmpresa'
						onChange={handleInpuntChange}
						fullWidth={true}
						size='large'
						
					/>
				</div> }
		</>
	);
};
